import {
  TestimonialMain,
  TestimonialGrid,
  TestimonialCard,
  TestimonialAvatar,
  TestimonialContent,
  TestimonialHeader,
  TestimonialStars,
  TrustedLogos,
} from "../../styles/testimonial";
import * as Icon from "react-feather";

const TestimonialComponent = () => {
  return (
    <TestimonialMain>
      <TestimonialHeader>
        <h2>Loved by developers worldwide</h2>
        <p>Join thousands of developers who trust Sixth to accelerate their workflow</p>
      </TestimonialHeader>

      <TestimonialGrid>
        {testimonials.map((item, index) => (
          <TestimonialCard key={index} featured={item.featured}>
            <TestimonialContent>
              <TestimonialStars>
                {[...Array(5)].map((_, i) => (
                  <Icon.Star
                    key={i}
                    size={16}
                    fill={i < item.stars ? "#FFD700" : "transparent"}
                    color={i < item.stars ? "#FFD700" : "#3a3a3a"}
                  />
                ))}
              </TestimonialStars>
              <p className="review">{item.review}</p>
              <div className="author">
                <TestimonialAvatar>
                  <span>{item.name.charAt(0)}</span>
                </TestimonialAvatar>
                <div className="author-info">
                  <p className="name">{item.name}</p>
                  <p className="role">{item.role}</p>
                </div>
              </div>
            </TestimonialContent>
          </TestimonialCard>
        ))}
      </TestimonialGrid>

      <TrustedLogos>
        {trustedCard.map((item, index) => (
          <div key={index} className="logo-item">
            <img  loading ="lazy" src={item.src} alt="logo" />
          </div>
        ))}
      </TrustedLogos>
    </TestimonialMain>
  );
};

export default TestimonialComponent;

const trustedCard = [
  {
    src: "/images/amazon.png",
  },
  {
    src: "/images/netflix2.png",
  },
  {
    src: "/images/airbnb.png",
  },
  {
    src: "/images/tesla.png",
  },
  {
    src: "/images/github logo.png",
  },
  {
    src: "/images/mono_logo.png",
  },
];

const testimonials = [
  {
    name: "Sarah Chen",
    role: "Senior Developer at Meta",
    review: "Sixth has transformed how I code. The intelligent suggestions are spot-on, and it's cut my development time by 40%. Absolutely essential for any serious developer.",
    stars: 5,
    featured: true,
  },
  {
    name: "Marcus Rodriguez",
    role: "Full Stack Engineer",
    review: "The real-time error detection has saved me countless hours of debugging. It's like having a senior developer looking over my shoulder.",
    stars: 5,
    featured: false,
  },
  {
    name: "Emily Thompson",
    role: "Tech Lead at Spotify",
    review: "My team's productivity has skyrocketed since we adopted Sixth. The collaboration features are unmatched.",
    stars: 5,
    featured: false,
  },
  {
    name: "David Kim",
    role: "DevOps Engineer",
    review: "Sixth understands context better than any AI tool I've used. It's dramatically improved my workflow efficiency.",
    stars: 4,
    featured: false,
  },
  {
    name: "Alex Johansson",
    role: "Frontend Architect",
    review: "The customization options let me tailor Sixth perfectly to our team's needs. Game-changing for large projects.",
    stars: 5,
    featured: false,
  },
  {
    name: "Priya Patel",
    role: "ML Engineer at Google",
    review: "From complex algorithms to simple scripts, Sixth handles it all brilliantly. It's become indispensable to my daily work.",
    stars: 5,
    featured: true,
  },
];
